import Title from 'components/Title';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { CartPlus } from 'styled-icons/fa-solid';
import TableQuote from './components/TableQuote';
import { Container } from './styles';

const Users: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Container>
      <Title>Cotações</Title>
      <Row>
        <Col xs={12} sm={6}>
          <Button
            variant="outline-primary"
            title="Cotações"
            onClick={() => navigate('addEditQuote')}
          >
            <CartPlus size="20" />
          </Button>
        </Col>
      </Row>
      <br />
      <TableQuote />
    </Container>
  );
};

export default Users;
